import { styled } from 'goober';

import { IQuizItem } from '../../types/quiz';

type Props = {
  item: IQuizItem;
};

export const QuestionText = ({ item }: Props) => (
  <Container>
    {item.title && <Title className="q-title">{item.title}</Title>}
    {item?.titleHtml && (
      <Title
        className="q-title"
        dangerouslySetInnerHTML={{ __html: item.titleHtml }}
      />
    )}
    {item.subtitle && (
      <Subtitle className="q-subtitle">{item.subtitle}</Subtitle>
    )}
    {item.subtitleHtml && (
      <Subtitle
        className="q-subtitle"
        dangerouslySetInnerHTML={{ __html: item.subtitleHtml }}
      />
    )}
  </Container>
);

const Container = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Title = styled('h1')`
  margin: 0;
  color: #3d3d3d;
  text-align: center;
  font-size: 2rem;
  line-height: 38px;
  font-weight: 700;

  @media (max-width: 569px) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`;

const Subtitle = styled('h2')`
  margin: 0;
  color: #3d3d3d;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
`;
